var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3998 6.39997V8.79995H1V6.39997C1.00186 5.76403 1.25532 5.15467 1.70499 4.70499C2.15467 4.25532 2.76403 4.00186 3.39997 4H20.9998C21.6357 4.00186 22.2451 4.2553 22.6948 4.70499C23.1445 5.15467 23.3979 5.76403 23.3998 6.39997V6.39997Z",
    fill: "#325D7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.3984V17.5984C1.00198 18.2344 1.25554 18.8437 1.7053 19.2934C2.15506 19.7431 2.76449 19.9965 3.40048 19.9983H21.0003C21.6362 19.9965 22.2455 19.743 22.6951 19.2933C23.1447 18.8436 23.398 18.2342 23.3998 17.5984V10.3984H1ZM9.80041 16.7984H5.00046C4.78829 16.7984 4.58481 16.7141 4.43478 16.5641C4.28475 16.414 4.20047 16.2105 4.20047 15.9984C4.20047 15.7862 4.28475 15.5827 4.43478 15.4327C4.58481 15.2827 4.78829 15.1984 5.00046 15.1984H9.80041C10.0126 15.1984 10.2161 15.2827 10.3661 15.4327C10.5161 15.5827 10.6004 15.7862 10.6004 15.9984C10.6004 16.2105 10.5161 16.414 10.3661 16.5641C10.2161 16.7141 10.0126 16.7984 9.80041 16.7984Z",
    fill: "#325D7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.1ff6877d.svg";
export { ForwardRef as ReactComponent };